<style scoped>
	.edi-detail-bill .detail-bill-footer {
		height: 80px;
	}
</style>
<template>
	<div class="edi-detail-bill">
		<!-- <div class="filter">
			<input type="text" placeholder="" class="ui-search-input"/>
		</div> -->
		<navbar title="单据统计-明细"></navbar>
		<div v-show="scrollShow" class="common-scroll detail-scroll">
			<p class="detail-bill-status">订单号：{{billCountSerials.trans_bill_no}}
				<span v-if="billCountSerials.bill_state == 10"  class="grey-font">
					<i v-if="billCountSerials.urgent_flag == 1" class="tips-flag">加急</i>未处理
				</span>
				<span v-if="billCountSerials.bill_state == 11"  class="aqua-font">
					<i v-if="billCountSerials.urgent_flag == 1" class="tips-flag">加急</i>待发货
				</span>
				<span v-if="billCountSerials.bill_state == 12"  class="orange-font">
					<i v-if="billCountSerials.urgent_flag == 1" class="tips-flag">加急</i>已发货
				</span>
				<span v-if="billCountSerials.bill_state == 20"  class="grey-font">
					<i v-if="billCountSerials.urgent_flag == 1" class="tips-flag">加急</i>未确认
				</span>
				<span v-if="billCountSerials.bill_state == 21"  class="red-font">
					<i v-if="billCountSerials.urgent_flag == 1" class="tips-flag">加急</i>已确认
				</span>
			</p>
			<div class="detail-bill-wrapper">
				<h4 class="detail-bill-address">{{billCountSerials.from_organ_name}}</h4>
				<ul class="detail-bill-list">
					<li v-for="detail in details">{{detail.goods_name}}({{detail.goods_unit}})
						<ul class="detail-bill-sonlist">
							<li class="detail-bill-fulllist" v-if="detail.goods_code">品项编号：{{detail.goods_code}}</li>
							<li>订货数量：{{detail.goods_num | numFixed(numScale)}}</li>
							<li>发货数量：{{detail.goods_num_send | numFixed(numScale)}}</li>
							<li>税率：{{detail.goods_cess}} %</li>
							<li>含税单价：{{detail.goods_price_send | numFixed(numScale)}}元</li>
							<li>价税合计：{{detail.sub_total_send | numFixed(numScale)}}元</li>
							<li>实收数量：{{detail.goods_num_recipient | numFixed(numScale)}}</li>
							<li>实收金额：{{detail.sub_total_recipient | numFixed(numScale)}}元</li>
							<div v-show="detail.goods_assist_unit">
								<li class="detail-bill-twolist">辅助单位：{{detail.goods_assist_unit}}</li>
								<li class="detail-bill-twolist">退货辅助数量：{{detail.goods_assist_num | numFixed(4)}}</li>
								<!-- <li class="detail-bill-twolist" style="height: 17px"></li> -->
							</div>
						</ul>
					</li>
				</ul>
			</div>
		</div>
		<div v-show="scrollShow" class="detail-bill-footer">
			<div class="detail-bill-info">
				<p>配送至：
					<span class="all-font" v-show="show">{{allInfo}}</span>
					<i @click="showAll('配送至：' + billCountSerials.to_organ_name)" style="width: auto">{{billCountSerials.to_organ_name}}</i>
				</p>
				<p>总计：
					<i @click="showAll('总计：' + (numScale ? billCountSerials.sum_money_send.toFixed(numScale) : billCountSerials.sum_money_send)+ '元')" style="width: auto">{{billCountSerials.sum_money_send | numFixed(numScale)}}元</i>
				</p>
				<p>退货辅助数量：
					<span class="all-font" v-show="show">{{allInfo}}</span>
					<i @click="showAll('退货辅助数量：' + sumGoodsAssistNumReturn)" style="width: auto">{{sumGoodsAssistNumReturn | numFixed(4)}}</i>
				</p>
			</div>
		</div>
		<loading v-show="loading"></loading>
	</div>
</template>

<script>
import Loading from '../components/loading'
import NavBar from '../components/NavBar'
export default {
	data () {
		return {
			scrollShow: false,
			show: false,
			loading: true,
			querySerialDetailData: this.$route.query,
			billCountSerials: {},
			details: {},
			numScale: 2,
			allInfo: ''
		}
	},
	components: {
		'loading': Loading,
		'navbar': NavBar
	},
	created () {
		this.loading = true
		var filterData = {
			bill_id: this.querySerialDetailData.bill_id
		}
		this.$http.post('/cldEdi/business/billWithDetail', filterData).then((response) => {
			this.loading = false
			this.scrollShow = true
			this.billCountSerials = response.body.data
			this.numScale = (this.billCountSerials.number_scale || this.billCountSerials.number_scale === 0) ? this.billCountSerials.number_scale : 2
			this.details = response.body.data.details
		})
	},
	filters: {
		// edi小数位数处理
		numFixed (val, scale) {
			// if (scale) {
			// 	return (parseFloat(val) || 0).toFixed(scale)
			// } else {
			return val
			// }
		}
	},
	methods: {
		showAll (val) {
			clearTimeout(timer)
			this.allInfo = val
			var self = this
			self.show = true
			var timer = setTimeout(() => {
				self.show = false
			}, 5000)
		}
	},
	computed: {
		sumGoodsAssistNumReturn () {
			let sumGoodsAssistNumReturn = 0
			if (this.details) {
				for (let i = 0; i < this.details.length; i++) {
					sumGoodsAssistNumReturn += this.details[i].goods_assist_num
				}
			}
			return sumGoodsAssistNumReturn
		}
	}
}
</script>



// WEBPACK FOOTER //
// BillCountSerialDetail.vue?45cdc48a